
import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from 'src/app/core/services/modules/common.service';
import {ProjectService} from 'src/app/core/services/modules/project.service';
import {DialogService} from 'src/app/core/services/utils/dialog.service';
import {FechasService} from 'src/app/core/services/utils/fechas.service';
import {SnackBarService} from 'src/app/core/services/utils/snackBar.service';
import {environment} from 'src/environments/environment';

export interface DialogData {
  Id: string;
  permissions: any[];
}

@Component({
  selector: 'app-dialog-create-project',
  templateUrl: './dialog-create-project.component.html',
  styleUrls: ['./dialog-create-project.component.scss']
})
export class DialogCreateProjectComponent implements OnInit {
  s3Bucket: string;
  imgCropperResult: string;

  form: FormGroup;
  GeoFenceJson: any;
  formEtapas: FormGroup;
  changeGeoFenceJson: any;
  formDataPhoto: FormData;

  daneCity: [] = [];
  permissions: string[] = [];
  projectStageArray: any[] = [];
  flagNext = false;
  flagEditEtapas = true;

  configStart = '{"type":"Polygon","coordinates":[]}';

  date = new Date();
  minDate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate());

  constructor(public dialogRef: MatDialogRef<DialogCreateProjectComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private commonService: CommonService,
              private dialogService: DialogService,
              private projectService: ProjectService,
              private snackBService: SnackBarService,
              public fechasService: FechasService,
              private fb: FormBuilder) {
      this.getServices();
      this.form = this.fb.group({
        Address: new FormControl('', Validators.required),
        CityCode: new FormControl('', Validators.required),
        CompanyInfoId: new FormControl(this.data.Id, Validators.required),
        GeoFence: new FormControl(''),
        JoinCompaniesList: new FormControl([]),
        Name: new FormControl('', Validators.required),
      });
      this.formEtapas = this.fb.group({
        Name: new FormControl('', Validators.required),
        Review: new FormControl('', Validators.required),
        StartDate: new FormControl(new Date(), Validators.required),
        FinishDate: new FormControl('', Validators.required),
      });
    }

  ngOnInit(): void {
    this.s3Bucket = environment.api.s3Bucket;
    this.GeoFenceJson = JSON.parse(this.configStart);
  }

  getServices() {
    this.commonService.getDaneCitySelectTrue().subscribe((daneCity: any) => {
      this.daneCity = daneCity;
    });
  }

  close() {
    this.dialogRef.close(false);
  }

  next() {
    if (this.form.status !== 'VALID') {
      this.snackBService.openWarning('Diligenciar los campos requeridos', '', 4000);
      this.form.markAllAsTouched();
    } else if (this.imgCropperResult === undefined){
      this.snackBService.openWarning('Falta cargar el logo', '', 4000);
    } else {
      this.flagNext = true;
    }
  }


  guardarEtapa() {
    if (this.formEtapas.status === 'VALID') {
      if (this.projectStageArray.length === 0) {
        this.projectStageArray.push(this.formEtapas.value);
      }
      this.projectStageArray.forEach(x => {
        if (x.Name === this.formEtapas.get('Name').value) {
          x.Name = this.formEtapas.get('Name').value;
          x.Review = this.formEtapas.get('Review').value;
          x.StartDate = this.formEtapas.get('StartDate').value;
          x.FinishDate = this.formEtapas.get('FinishDate').value;
        } else {
          this.projectStageArray.push(this.formEtapas.value);
        }
      });
      this.formEtapas.get('Name').setValue('');
      this.formEtapas.get('Review').setValue('');
      this.formEtapas.get('StartDate').setValue(new Date());
      this.formEtapas.get('FinishDate').setValue('');
      this.flagEditEtapas = true;
    } else {
      this.formEtapas.markAllAsTouched();
    }
  }

  addEtapa() {
    this.flagEditEtapas = false;
    this.formEtapas.get('Name').setValue('');
    this.formEtapas.get('Review').setValue('');
    this.formEtapas.get('StartDate').setValue(new Date());
    this.formEtapas.get('FinishDate').setValue('');
  }

  editarEtapaProject(stage: { Name: any; Review: any; StartDate: any; FinishDate: any; }) {
    this.flagEditEtapas = false;
    this.formEtapas.get('Name').setValue(stage.Name);
    this.formEtapas.get('Review').setValue(stage.Review);
    this.formEtapas.get('StartDate').setValue(stage.StartDate);
    this.formEtapas.get('FinishDate').setValue(stage.FinishDate);
  }

  eliminarEtapa(stage: { Name: any; }){
    this.projectStageArray.forEach((x, index) => {
      if (x.Name === stage.Name) {
        this.projectStageArray.splice(index, 1);
      }
    });
  }

  getImgEtapa(logo: any) {
    return (logo === null ? 'assets/images/bg/project.png' : logo);
  }

  save() {
    if (this.projectStageArray.length === 0) {
      this.snackBService.openWarning('Debes crear una etapa', '', 4000);
    } else if (this.form.status === 'VALID')  {
      this.projectStageArray.forEach(x => {
        x.StartDate = this.fechasService.getDateFormatDatePiker(x.StartDate);
      });
      const model = {
        Address: this.form.get('Address').value,
        CityCode: this.form.get('CityCode').value,
        CompanyInfoId: this.form.get('CompanyInfoId').value,
        GeoFence: this.changeGeoFenceJson ? this.toJSONString(this.configStart) : '',
        JoinCompaniesList: [],
        Name: this.form.get('Name').value,
        ProjectStageList: this.projectStageArray
      };
      this.projectService.postProject(model).subscribe((rest: any) => {
        if (this.formDataPhoto === undefined) {
          this.dialogRef.close(rest.Id);
        } else {
          this.projectService.putProjectUpdateLogo(rest.Id, this.formDataPhoto).subscribe((response) => {
            this.dialogRef.close(response.Id);
          });
        }
      });
    }
  }

  private toObject<T = any>(input: any): T | undefined {
    if (input == null || input === '') { return undefined; }
    if (typeof input === 'string') {
      try { return JSON.parse(input) as T; } catch { return undefined; }
    }
    return input as T;
  }

  private toJSONString(input: any): string {
    if (input == null || input === '') { return ''; }
    if (typeof input === 'string' && /^[\[{]/.test(input.trim())) { return input; }
    try { return JSON.stringify(input); } catch { return ''; }
  }

  openDialogMap() {
    const initial = this.toObject(this.configStart);

    this.dialogService.openDialogMap('', initial).afterClosed().subscribe(rest => {
      if (rest === false || rest == null) { return; }

      const obj = this.toObject(rest) ?? rest;

      this.configStart = obj;
      this.changeGeoFenceJson = this.toJSONString(obj);
      this.GeoFenceJson = this.toObject(this.changeGeoFenceJson) ?? obj;
    });
  }

  updatePhotoPersonal(): void {
    const adminId = this.form.get('CompanyInfoId')?.value || this.data.Id || '';

    (this.dialogService.openDialogGestorImg as any)('CARGAR IMAGEN', [], 'editPhoto', 0, 'true', true, undefined, false, false, adminId
    ).afterClosed().subscribe((result: any) => {
      if (!result) { return; }

      const MAX = 10_000_000;
      const isFormData = (x: any): x is FormData => x && typeof x.append === 'function' && typeof x.get === 'function';

      const original = result?.meta?.originalBytes as number | undefined;
      if (typeof original === 'number' && original > MAX) {
        this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 5000);
        return;
      }

      const fd: FormData = isFormData(result) ? result : isFormData(result?.FormData) ? result.FormData : null;
      if (!fd) { return; }

      const file = fd.get('File') as File | Blob | null;
      if (!file) { return; }

      if (file.size > MAX) {
        this.snackBService.openWarning('El archivo supera el peso máximo permitido de 10 MB', '', 5000);
        return;
      }
      if (file) {
        const name = (file as any).name || '';
        const type = (file as any).type || '';
        const ok =
          ['image/jpg', 'image/jpeg', 'image/png'].includes(type) &&
          /\.(jpg|jpeg|png)$/i.test(name);
        if (!ok) {
          this.snackBService.openWarning('Solo se permite subir archivos en formatos JPG y PNG.', '', 5000);
          return;
        }
      }
      this.imgCropperResult = result?.imgResult ?? this.imgCropperResult;
      this.formDataPhoto = fd;
    });
  }

  exitPermission(permiso: string): boolean {
    let exit: boolean;
    const permisionsUserInfo  = this.data.permissions.find(x => x === permiso);
    permisionsUserInfo !== undefined ? exit = true : exit = false;
    return exit;
  }


}
